import classes from "../classes";
import horseRunning from "../../public/images/horse-running-large.gif";
import horseRunningDark from "../../public/images/horse-running-large-gray.gif";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function Loading({ dark, message }) {
  var img = horseRunning;
  if (dark) {
    img = horseRunningDark;
  }
  return (
    <div className={classes({
      "loading": true,
      "loading--inline": true,
      "loading--is-dark": dark
    })}>
      <div className="loading_content">
        <div>
          <span className="loading_heading">
            {message || "Loading"}
          </span>

          <ul className="loading_ellipsis">
            <li />

            <li />

            <li />
          </ul>
        </div>

        <img className="loading_gif" src={img} />
      </div>
    </div>
  );
});
